import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Info2 = (props) => (
  <Icon viewBox="0 0 18 18" {...props}>
    <g>
      <title>!</title>
      <path d="M10 12V7H8L7 9h1v3l-1 2h4l-1-2zM8 6h2V4H8v2zm1 11c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zM9 0a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9z"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Info2;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Info2.js